// extracted by mini-css-extract-plugin
module.exports = {"customerManagementTabs":"CustomerManagementTabs_customerManagementTabs__16et3","customerManagementTabsContainer":"CustomerManagementTabs_customerManagementTabsContainer__3jYWW"};